import { useSession } from '@hooks/security/use-session';
import { useOptOut } from '@hooks/register/use-opt-out';
import { useLocalize } from '@hooks/use-localize';
import type { IOptOutModel, IOptOutSubmitResult } from '@/types/history/opt-out';

const OptOut = () => {
    const { registrationId, editKey } = useSession();
    const { model, isLoading, error, submit, isSubmitting, submitError } = useOptOut(registrationId, editKey);

    if (isLoading) {
        return (
            <div className="row">
                <div className="col-xs-12">Loading&hellip;</div>
            </div>
        );
    }

    return (
        <>
            {error && (
                <div className="row">
                    <div className="col-xs-12">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                </div>
            )}
            <OptOutContent
                model={model}
                isSubmitting={isSubmitting}
                submitError={submitError}
                onSubmit={submit}
            />
        </>
    );
};

interface IOptOutContentProps {
    model: IOptOutModel;
    isSubmitting: boolean;
    submitError: string | null;
    onSubmit: () => Promise<IOptOutSubmitResult>;
}

const OptOutContent = ({ model, isSubmitting, submitError, onSubmit }: IOptOutContentProps) => {
    const t = useLocalize(model.languageData);

    return (
        <div className='container'>
            <div className="row">
                <div className="col-xs-12">
                    {model.isIE && (
                        <div className="alert alert-warning">
                            {t(
                                'Alert_BrowserRecommend',
                                'To ensure proper function of this site, we recommend that you use Chrome or FireFox.',
                            )}
                        </div>
                    )}

                    {model.stopCommunication ? (
                        <>
                            <h1>{t('DashLabel_YouHaveBeenOptedOut', 'You have been opted-out')}</h1>

                            <p>
                                {t('DashLabel_YouHaveBeenOptedOutOngoing', 'You have been opted-out of any ongoing, automated follow-up e-mails. However, this does not necessarily mean that you will no longer be contacted by the center, if applicable')}
                                .
                            </p>
                        </>
                    ) : (
                        <>
                            <h1>
                                {t('DashLabel_OptOutOfAllComm', 'Opt-Out of all communications')}?
                            </h1>

                            <p>
                                {t('DashLabel_PleaseConfirmThatYouWouldLike', 'Please confirm that you would like to opt-out of all communication. You may still receive some e-mails if certain actions were already triggered, but our automated system will no longer send reminders, etc')}
                                .
                            </p>
                            <br />

                            {submitError && <div className="alert alert-danger">{submitError}</div>}

                            <button
                                type="button"
                                className="btn btn-danger"
                                style={{ width: 300 }}
                                disabled={isSubmitting}
                                onClick={() => void onSubmit()}
                            >
                                {t('DashLabel_PleaseOptMeOut', 'Yes, Please Opt Me Out')}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OptOut;
